import ReactMarkdown from 'react-markdown';
import { Book } from "../../types/types";

const BookPreview = ({book} : {book?:Book}) => {

  return (
    <div className="xl:max-w-[800px]">
      <div className="flex justify-between pt-8 mb-8">
        <div className="flex items-center sm:gap-4 gap-2">
          <div className=" sm:size-20 size-12 rounded-full overflow-hidden border border-black/20">
            <img
              className="object-cover object-[25%_75%] "
              src={book?.author?.photo}
              alt="Instructor"
            />
          </div>
          <div className="text-burntBlack font-bold text-xl">
            <h1 className="mb-0.5 sm:text-xl text-lg">Dr. {book?.author?.firstName} {book?.author?.lastName}</h1>
            <p className="text-lightGray font-medium sm:text-lg tracking-[0.02em]">
              Instructor
            </p>
          </div>
        </div>
      </div>
      <div className="sm:mb-12 mb-7">
      <h1 className="font-bold sm:text-3xl  text-xl sm:mb-3 mb-1">{book?.name}</h1>
        <h2 className="font-bold sm:text-2xl text-lg tracking-[0.02em] sm:mb-4 mb-2.5">
          Description
        </h2>
        <p className="font-medium sm:text-lg text-sm text-lightGray text-justify">
        <ReactMarkdown>{book?.description}</ReactMarkdown>
        </p>
      </div>

    </div>
  );
};

export default BookPreview;
